import { createSlice,createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import {BASE_URL} from '../../utils/commonUrl'
const initState = {
    isLoading:false,
    message:'',
    matrixOpinion:[]
}

export const fetchMatrixOpinion = createAsyncThunk('matrixopinion/getall', async () => {
    const response = await axios.get(`${BASE_URL}/api/matrixopinion`)
    return response.data
  })


let userSlice = createSlice({
  name:'matrixOpinion',
  initialState:initState,
  extraReducers:(builder)=>{
      builder
      .addCase(fetchMatrixOpinion.pending,(state)=>{
          state.isLoading = true
      })
      .addCase(fetchMatrixOpinion.fulfilled,(state,action)=>{
          state.isLoading = false
          state.matrixOpinion = action.payload
      })
      .addCase(fetchMatrixOpinion.rejected,(state,payload)=>{
          state.isLoading = false
          state.message = payload.data.message
      })

  },
  reducers:{
      
  
  }
})

//export const {} = userSlice.actions;

export default userSlice.reducer;